module.exports = __webpack_public_path__ + "img/een-logo-white.91843b36.png";